// extracted by mini-css-extract-plugin
module.exports = {"container":"BonusesLockedBalance_container__QnTSU","locked":"BonusesLockedBalance_locked__1zBuT","balance":"BonusesLockedBalance_balance__MuMWT"};